import { Flex, VFlex } from '@/components/base';

import DimensionFieldMenu from './field-menu';
import DimensionFieldSelector from './field-selector';
import { useDimensionHandlers } from './hooks';

type Props = {
  chartInfo: ChartContextProps;
  allowTop?: boolean;
  switchFlag: number;
  chartSeriesIndex?: number;
};

export const ChartDimensionSelect = ({
  chartInfo,
  allowTop,
  switchFlag,
  chartSeriesIndex,
}: Props) => {
  const {
    isColumn,
    targetField,
    handleFieldChange,
    handleFieldItemChange,
    handleTopLabelClick,
    handleHeaderTopLabelClick,
    handleClear,
  } = useDimensionHandlers({ chartInfo, chartSeriesIndex });

  return (
    <VFlex g={12}>
      <Flex g={12}>
        <DimensionFieldMenu
          targetFieldType={targetField.type}
          onFieldChange={handleFieldChange}
        />
      </Flex>
      <DimensionFieldSelector
        chartInfo={chartInfo}
        targetField={targetField}
        switchFlag={switchFlag}
        isColumn={isColumn}
        allowTop={allowTop}
        onFieldItemChange={handleFieldItemChange}
        onTopLabelClick={handleTopLabelClick}
        onHeaderTopLabelClick={handleHeaderTopLabelClick}
        onClear={handleClear}
      />
    </VFlex>
  );
};

ChartDimensionSelect.FieldSelector = DimensionFieldSelector;
ChartDimensionSelect.FieldMenu = DimensionFieldMenu;
